<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>깜짝퀴즈정보</div>
      <!-- Breadcrumb right aligned-->
      <!-- <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">컨텐츠관리</a>
        </li>
        <li class="breadcrumb-item active">개체정보</li>
      </ol> -->
    </div>

    <!-- 상세 -->
    <div class="card card-default">
      <!--<div class="card-header">상세</div>-->
      <div class="card-body">
        <form data-vv-scope="edit">
          <table class="table table-bordered" style="background-color: #f7f7f7;">
            <colgroup>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
            </colgroup>
            <tr>
              <th>깜짝퀴즈시퀀스</th>
              <td>
                <span>{{data.row.kjQuizSeq}}</span>
              </td>
              <th>콘텐츠 ID</th>
              <td>
                <span>{{data.row.contSeq}}</span>
              </td>
            </tr>
            <tr>
              <th>제목</th>
              <td>
                 <span>{{data.row.contTitle}}</span>
              </td>
              <th>등록자</th>
              <td>
                 <span>{{data.row.userId}}</span>
              </td>
            <tr>
              <th>등록일</th>
              <td>
                 <span>{{data.row.regDt}}</span>
              </td>
              <th>수정일</th>
              <td>
                 <span>{{data.row.updDt}}</span>
              </td>
            </tr>
          </table>
          <table class="table table-bordered mt-4">
            <colgroup>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
              <col width="15%" class="bg-lightdark"/>
              <col width="35%"/>
            </colgroup>
            <tr>
              <th>카테고리</th>
              <td colspan='3'>
                <Keyword :boxLimit="10" :box="categorys.box" :boxText="categorys.text" :type="'category'" :cateOptions="categorys.options" @keywordChange="keywordChange" @keywordRemove="keywordRemove" :key="categorys.text"/>
              </td>
            </tr>
            <tr>
              <th>설명글</th>
              <td colspan='3'>
                <!-- <textarea maxlength="200" name="Text1" v-model="data.comment" rows="1" style="width:100%;"></textarea> -->
                <input maxlength="200" type="text" v-model="data.comment" class="form-control mb-2">
              </td>
            </tr>
            <tr>
              <th>키워드</th>
              <td colspan='3'>
                <Keyword :boxLimit="5" :box="keywords.box" :boxText="keywords.text" :type="'key'" @keywordChange="keywordChange" @keywordRemove="keywordRemove" :key="keywords.text"/>
              </td>
            </tr>
            <tr>
             <th>추천정보</th>
              <td colspan="4">
                <b-input-group>
                   <div>
                      <div class="form-check mb-2">
                        <input class="form-check-input" v-model="data.grd_chk_yns[0]" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label">초1</label>
                        <input class="form-check-input ml-2" v-model="data.grd_chk_yns[1]" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">초2</label>
                        <input class="form-check-input ml-2" v-model="data.grd_chk_yns[2]" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">초3</label>
                        <input class="form-check-input ml-2" v-model="data.grd_chk_yns[3]" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">초4</label>
                        <input class="form-check-input ml-2" v-model="data.grd_chk_yns[4]" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">초5</label>
                        <input class="form-check-input ml-2" v-model="data.grd_chk_yns[5]" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">초6</label>
                        <input class="form-check-input ml-2" v-model="data.grd_chk_yns[6]" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">중1</label>
                        <input class="form-check-input ml-2" v-model="data.grd_chk_yns[7]" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">중2</label>
                        <input class="form-check-input ml-2" v-model="data.grd_chk_yns[8]" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">중3</label>
                        <input class="form-check-input ml-2" v-model="data.grd_chk_yns[9]" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">고1</label>
                        <input class="form-check-input ml-2" v-model="data.grd_chk_yns[10]" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">고2</label>
                        <input class="form-check-input ml-2" v-model="data.grd_chk_yns[11]" true-value="Y" false-value="N" type="checkbox"/>
                        <label class="form-check-label ml-4">고3</label>
                      </div>
                   </div>
                 </b-input-group>
              </td>
            </tr>
          </table>
        </form>
      </div>
    </div>
    <div> 
      <div div class="content-heading mt-1" >
        <div>교과서매핑정보</div>
      </div>
      <div class="card card-default">
        <div class="card-body">
            <table class="table table-bordered">
              <colgroup>
                <col width="100%" class="bg-lightdark"/>
              </colgroup>
              <tr v-for="(mapInfo) in data.mappingInfoList" v-bind:key="mapInfo">
                <th>{{ mapInfo }}</th>
                <!-- <td>{{ mapInfo }}</td> -->
              </tr>
            </table>
        </div>
        <!-- <div class="card-footer">
          <div class="card-tool float-right">
            <b-button @click="close()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2">목록</b-button>
            <b-button @click="removeMpp()" class="btn btn-xs btn-outline-danger mr-2" variant="outline-info mr-2">매핑삭제</b-button>
            <b-button @click="saveAll()" class="btn btn-xs btn-outline-info mr-2" variant="outline-info mr-2 px-3">저장</b-button>
          </div>
        </div> -->
     </div>
    </div>
    <div class="footer">
      <div class="float-right">
          <b-button @click="modalClose()" class="btn btn-b btn-outline-danger mr-2" variant="outline-info mr-2">취소</b-button>
          <b-button @click="modalClose('save')" class="btn btn-b btn-info mr-2" variant="info mr-2">저장</b-button>
      </div>
    </div>
    <a id="fileDown" style="display:none;"></a> <!-- 다운로드용 가상 a-->   
    <a id="filePreview" style="display:none;" target="_blank" ></a> <!-- 미리보기용 가상 a-->    
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getCsCodeList} from "@/api/cs/CsCodeApi";
import {getCsKjquizList, saveCsKjquiz} from "@/api/cs/CsKjquizApi";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject} from "@/utils/Constants";
import Keyword from "../../components/Common/Keyword";
import Axios from 'axios';

export default {
  components: {Keyword},
  props: {
    contSeq: Number,
  },
  setup(props, context) {
    const schOptions = [{value: 'disp_file_nm', text: '파일명'}, {value: 'ext_file_id', text: '파일 아이디'},{value: 'org_file_nm', text: '원본파일명'}]
    const _dataObject = _.cloneDeep(dataObject); //cloneDeep 객체복사 
    const data = reactive(_dataObject) //reactive 반응형 
    data.schOptions = schOptions // 검색 type 선택 

    const keywords = reactive({
      box : [],
      text : '',
    });
    const categorys = reactive({
      box : [],
      text : '',
      options : [],
    });
    const subjectLOW = {
      codes : [],       // 과목 code object 리스트
    };
    const subjectMID = {
      codes : [],       // 과목 code object 리스트
    };
    const subjectHIGH = {
      codes : [],       // 과목 code object 리스트
    };

    data.comment = '';

    data.grd_chk_yns = 'NNNNNNNNNNNN'.split('');
    let kjquizCodeList = [];

    const loadCategory = async () => {
      const result = await getCsCodeList({pCode: 'KJ_QUIZ_CATEGORY_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
      kjquizCodeList = result.data;
      console.log('kjquiz code list', kjquizCodeList); // test

      const resultLOW = await getCsCodeList({pCode: 'LOW_SUBJECT_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
      subjectLOW.codes = resultLOW.data || [];

      const resultMID = await getCsCodeList({pCode: 'MID_SUBJECT_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
      subjectMID.codes = resultMID.data || [];

      const resultHIGH = await getCsCodeList({pCode: 'HIGH_SUBJECT_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
      subjectHIGH.codes = resultHIGH.data || [];

      const resultKJSUBJECT = await getCsCodeList({pCode: 'KJ_QUIZ_SUBJECT_CD', ignoreRegId: true, sort: 'code', direction: 'asc'});
      if (resultKJSUBJECT.data && resultKJSUBJECT.data.length > 0) {
        resultKJSUBJECT.data.forEach(sub => {
          if (sub.code.startsWith('3280')) subjectLOW.codes.push(sub);
          else if (sub.code.startsWith('3281')) subjectMID.codes.push(sub);
          else if (sub.code.startsWith('3282')) subjectHIGH.codes.push(sub);
        });
      }

      console.log('subject code list LOW', subjectLOW.codes); // test
      console.log('subject code list MID', subjectMID.codes); // test
      console.log('subject code list HIGH', subjectHIGH.codes); // test
    }
    const getWithSubjectText = (subjectCodes) => {
      let withSubs = [[],[],[]];
      subjectCodes.forEach(subcode => {
        if (!!subcode) {
          let rv = [subjectLOW,subjectMID,subjectHIGH].some((subs,idx) => { return subs.codes.some(sub => {
            return sub.code == subcode ? (withSubs[idx].push(sub.codeNm), true) : false;
          })});
        }
      });
      return (withSubs[0].length ? ` (초등)${withSubs[0].join('/')}`:``)
            +(withSubs[1].length ? ` (중등)${withSubs[1].join('/')}`:``)
            +(withSubs[2].length ? ` (고등)${withSubs[2].join('/')}`:``);
    }
    const loadData = async () => {
      // modal open
      await loadCategory();
      categorys.options.length = 0;
      kjquizCodeList.forEach(e => {
        let text = e.codeNm;
        const withSubsText = getWithSubjectText(e.val1.split(','));
        if (!!withSubsText) text += ` : ${withSubsText}`;
        categorys.options.push({value: e.code, text});
      });

      data.params.contSeq = props.contSeq
      const result = await getCsKjquizList(data.params);
      console.log('first item', result.data[0]); // test
      data.row = result.data[0];
      data.comment = data.row.comment;
      data.grd_chk_yns = 'NNNNNNNNNNNN'.split('');
      for (let i = 0; i < 12; i++) {
        data.grd_chk_yns[i] = (data.row.grdChkYns>>i)&1 ? 'Y' : 'N';
      }
      data.mappingInfoList = !!data.row.mappingInfo ? data.row.mappingInfo.split(';') : [];
      settingKeywords(data.row.keywords);
      settingCategorys(data.row.categoryCds);

    }
    const settingKeywords = (text) => {
     if(text != null && text != ''){
        let _keywords = clearKeyword();
        _keywords.text = text.replace(/;#/g,',').replace(/[;#]/g,'');
        _keywords.box = _keywords.text.split(",").filter(e => e.length > 0);
        text = '';
      }
      text = '';
    }
    function clearKeyword(){
      let _keywords = keywords;
      _keywords.box = [];
      _keywords.text = '';
      return _keywords;
    }
    const getCategoryStr = (categoryCds) => {
      let str = [];
      categoryCds.split(',').forEach(cd => {
        let el = kjquizCodeList.find(e => e.code == cd );
        if (el) {
          let text = el.codeNm;
          const withSubsText = getWithSubjectText(el.val1.split(','));
          if (!!withSubsText) text += ` : ${withSubsText}`;
          str.push(text);
        }
      });
      return str.join(',');
    }
    const settingCategorys = (text) => {
      if(text != null && text != ''){
        let _categorys = clearCategory();
        _categorys.text = text;
        _categorys.box = getCategoryStr(_categorys.text).split(',');
        text = '';
      }
      text = '';
    }
    function clearCategory(){
      let _categorys = categorys;
      _categorys.box = [];
      _categorys.text = '';
      return _categorys;
    }

    const keywordChange = (box,text,type) =>{
      if(type == "key"){
        keywords.box = box;
        keywords.text = text;
      }else{
        categorys.box = box;
        categorys.text = text;
      }
    }

    const keywordRemove = ( box , text , type) =>{
      if(type == "key"){
         keywords.box = box;
         keywords.text = text;
      }
      else{
        categorys.box = box;
        categorys.text = text;
      }
    }

    const close = () =>{
        context.emit('get-data', {
          contSeq : props.contSeq,
          version : 'info'
      });
    }

    const checkModified = () => {
      let isModified = false;
      if (categorys.text != data.row.categoryCds) {
        console.log('category modified', data.row.categoryCds, '->', categorys.text);
        isModified = true;
      }
      let text = keywords.text.split(',').filter(e=>!!e).join(';#');
      if (text.length > 0) text = '#'+text+';';
      if (text != data.row.keywords) {
        console.log('keywords modified', data.row.keywords, '->', text);
        isModified = true;
      }
      let grdChkYns = 0;
      data.grd_chk_yns.forEach((e,idx) => { if (e=='Y') grdChkYns += 1<<idx; });
      if (grdChkYns != data.row.grdChkYns) {
        console.log('grd_chk_yns modified', data.row.grdChkYns, '->', grdChkYns);
        isModified = true;
      }
      if (data.comment != data.row.comment) {
        console.log('comment modified', data.row.comment, '->', data.comment);
        isModified = true;
      }
      return isModified;
    }
    const save = async () => {
      let text = keywords.text.split(',').filter(e=>!!e).join(';#');
      if (text.length > 0) text = '#'+text+';';

      let grdChkYns = 0;
      data.grd_chk_yns.forEach((e,idx) => { if (e=='Y') grdChkYns += 1<<idx; });

      let params = {
        kjQuizSeq: data.row.kjQuizSeq,
        useYn: data.row.useYn,
        comment: data.comment,
        categoryCds: categorys.text,
        keywords: text,
        grdChkYns: grdChkYns,
      }
      try {
        const result = await saveCsKjquiz(params);
        if (result.data != data.row.kjQuizSeq) {
          console.log(`저장에 실패했습니다.:${result.data}`);
        } else {
          return true; // success
        }
      } catch (e) {
        console.log(`저장에 실패했습니다.:${e.message}`);
      }
      return false;
    }

    const modalClose = async (type) =>{
        let isModified = false;
        if (type == 'save') {
            if (checkModified()) {
                const isSaved = await save();
                if (isSaved) {
                    context.emit('modal-state','info', true);
                } else {
                    alert('저장에 실패했습니다.')
                }
            } else {
                alert('변경된 내용이 없습니다.')
            }
        } else {
            context.emit('modal-state','info');
        }
    }

    onMounted(loadData);
    
    return {
      close,
      data,
      keywords,
      categorys,
      settingKeywords,
      clearKeyword,
      settingCategorys,
      clearCategory,
      keywordChange,
      keywordRemove,
      modalClose,
      dataAction: new TableActionClass(data),
    }
  },
}

</script>
